import { render } from "./TokenComparison.vue?vue&type=template&id=18ffea47&scoped=true"
import script from "./TokenComparison.vue?vue&type=script&lang=js"
export * from "./TokenComparison.vue?vue&type=script&lang=js"

import "./TokenComparison.vue?vue&type=style&index=0&id=18ffea47&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ffea47"],['__file',"resources/js/components/TokenComparison.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18ffea47"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18ffea47', __exports__)) {
    api.reload('18ffea47', __exports__)
  }
  
  module.hot.accept("./TokenComparison.vue?vue&type=template&id=18ffea47&scoped=true", () => {
    api.rerender('18ffea47', render)
  })

}


export default __exports__